<template>
	<div>
		<div class="main-header">
			<div class="container">
				<h2 class="main-header-text">Change Profile</h2>
			</div>
		</div>
		<!-- eo main header -->
		<div class="main-section mgt-40">
			<div class="container">
				<div class="main-card">
					<img src="/static/img/icons/arrow-down-indicator-red.png" alt="" class="top-indicator" />
					<div class="row">
						<div class="col-lg-8">
							<form @submit.prevent="onSubmit" novalidate="" autocomplete="off">
								<div class="form-card">
									<div class="form-card-header">
										<h3>Personal Details</h3>
									</div>

									<div class="form-card-forms">
										<div class="row">
											<div class="col-lg-6">
												<div class="form-group">
													<label for="">
														Occupation<span class="required">*</span>
													</label>
													<div class="mb-3">

														<select class="form-control classic" name="OccupationId"
															v-model="vModel.OccupationId" v-validate="'required'"
															@change="onOccupationChange" data-vv-as='Occupation'>
															<option :value="null">Please Select Occupation</option>
															<option v-for="option in OccupationCollection"
																:key="option.Id" :value="option.Id">
																{{option.Text}}
															</option>
														</select>


														<!--<kendo-dropdownlist v-if='OccupationCollection != null' name='OccupationId' v-validate="'required'" class="form-control" @dataBound="onDataBound"
																								:class="{'input': true, 'is-danger': errors.has('OccupationId') }" v-model="vModel.OccupationId"
																								:data-text-field="'Text'" :data-source="OccupationCollection" :data-value-field="'Id'" :option-label="'Please Select Occupation'"
																								data-vv-as='Occupation' :auto-bind="true" v-on:change='onOccupationChange' :data-value-primitive="true"
																								ref="OccupationId">
														</kendo-dropdownlist>-->

														<div v-show="errors.has('OccupationId')" class="help is-danger">
															{{ errors.first('OccupationId') }}</div>
													</div>
												</div>
											</div>

											<div class="col-lg-6" v-if="1==2">
												<div class="form-group">
													<label for="">Bonus Link Number</label>
													<input type="text" class="form-control text-uppercase"
														id="BonusCardNumber" name="BonusCardNumber" v-only-numeric=""
														autocomplete="off" placeholder="Please Enter Bonus Card Number"
														v-model="vModel.BonusCardNumber"
														v-validate="'validateBonusLink'" data-vv-as='Bonus Card Number'
														:class="{'input': true, 'is-danger': errors.has('BonusCardNumber') }" />
													<div v-show="errors.has('BonusCardNumber')" class="help is-danger">
														{{ errors.first('BonusCardNumber') }}
													</div>
												</div>
											</div>
										</div>
										<div class="row">
											<div class="col-lg-6" v-if="SubOccupationCollection.length > 0">
												<div class="form-group">
													<label for="">
														Sub Occupation
													</label>
													<div class="mb-3">
														<select class="form-control classic" name="SubOccupationId"
															v-model="vModel.SubOccupationId" v-validate="'required'"
															@change="onSubOccupationChange" data-vv-as='Sub Occupation'>
															<option :value="null">Please Select Sub Occupation</option>
															<option v-for="option in SubOccupationCollection"
																:key="option.Id" :value="option.Id">
																{{option.Text}}
															</option>
														</select>
														


														<!--<kendo-dropdownlist name='SubOccupationId' ref="SubOccupationDropdownList" class="form-control"
																								:class="{'input': true, 'is-danger': errors.has('SubOccupationId') }"
																								v-model="vModel.SubOccupationId" :data-text-field="'Text'" :data-value-field="'Id'" :auto-bind="true"
																								:option-label='"Select Sub Occupation"' :data-source="SubOccupationCollection" v-on:change='onSubOccupationChange'>
														</kendo-dropdownlist>-->
														<div v-show="errors.has('SubOccupationId')"
															class="help is-danger">
															{{ errors.first('SubOccupationId') }}
														</div>
													</div>
												</div>
												<!-- eo form group -->
											</div>
											<div class="col-lg-6" v-if="ShowEmploymentIndustry">
												<div class="form-group">
													<label for="">
														Employment Industry<span class="required">*</span>
													</label>
													<div class="mb-3">
														<select class="form-control classic" name="EmploymentIndustryId"
															v-model="vModel.EmploymentIndustryId" v-validate="'required'"
															@change="onSubOccupationChange" data-vv-as='Employment Industry'>
															<option :value="null">Please Select Employment Industry</option>
															<option v-for="option in EmploymentIndustries"
																:key="option.Id" :value="option.Id">
																{{option.Text}}
															</option>
														</select>
														<div v-show="errors.has('EmploymentIndustryId')"
															class="help is-danger">
															{{ errors.first('EmploymentIndustryId') }}
														</div>
													</div>
												</div>
												<!-- eo form group -->
											</div>
											<!-- eo col -->

											<div class="col-lg-6" v-if="EmploymentLevelCollection.length > 0">
												<div class="form-group">
													<label for="">
														Employment Level
													</label>
													<div class="mb-3">
														<!--<kendo-dropdownlist ref="EmploymentLevelDownList" name='EmploymentLevelId' class="form-control" :class="{'input': true, 'is-danger': errors.has('EmploymentLevelId') }"
																										v-model="vModel.EmploymentLevelId" :data-text-field="'Text'" :data-value-field="'Id'" data-vv-as='Employment Level'
																										:option-label='"Select Employment Level"' :data-source="EmploymentLevelCollection">
														</kendo-dropdownlist>-->

														<select class="form-control classic" name="EmploymentLevelId"
															v-model="vModel.EmploymentLevelId" v-validate="'required'"
															data-vv-as='Employment Level'>
															<option :value="null">Please Select Employment Level
															</option>
															<option v-for="option in EmploymentLevelCollection"
																:key="option.Id" :value="option.Id">
																{{option.Text}}
															</option>
														</select>

														<div v-show="errors.has('EmploymentLevelId')"
															class="help is-danger">

															{{ errors.first('EmploymentLevelId') }}
														</div>
													</div>
												</div>
												<!-- eo form group -->
											</div>
											<!-- eo col -->
										</div>

										<div>
											<div class="row">

												<div class="col-lg-6">
													<div class="form-group">
														<label for="">
															Unit No & Street Address<span class="required">*</span>
														</label>
														<input type="text" class="form-control text-uppercase"
															@input="onInput" id="Street" name="Street"
															placeholder="Please Enter Unit No & Street Address" autocomplete="off"
															v-model="vModel.Street" data-vv-as='Unit No & Street Address'
															v-only-uppercase v-validate="'required'"
															:class="{'input': true, 'is-danger': errors.has('Street') }" />
														<div v-show="errors.has('Street')" class="help is-danger">
															{{ errors.first('Street') }}
														</div>
													</div>
												</div>

												<div class="col-lg-6">
													<div class="form-group">
														<label for="">
															State<span class="required">*</span>
														</label>
														<div class="mb-3">
															<!--<kendo-dropdownlist data-vv-as='State' v-if='StatesCollection != null' name='StateId' v-validate="'required'"
																									class="form-control" :class="{'input': true, 'is-danger': errors.has('StateId') }" v-model="vModel.StateId"
																									:data-text-field="'Text'" :data-value-field="'Id'" :option-label="'Please Select State'" :auto-bind="true"
																									:index="0" :data-value-primitive="true" :data-source="StatesCollection">
															</kendo-dropdownlist>-->

															<select class="form-control" name="StateId"
																@change="onInput" v-model="vModel.StateId"
																v-validate="'required'" data-vv-as='State'>
																<option value="">Please Select State</option>
																<option v-for="option in StatesCollection"
																	:key="option.Id" :value="option.Id">
																	{{option.Text}}
																</option>
															</select>

															<div v-show="errors.has('StateId')" class="help is-danger">
																{{ errors.first('StateId') }}</div>

														</div>
													</div>
												</div>

												<div class="col-lg-6">
													<div class="form-group">
														<label for="">
															City<span class='required'>*</span>
														</label>
														<input type="text" class="form-control  text-uppercase"
															@input="onInput" id="City" v-only-uppercase name="City"
															placeholder="Please Enter City" autocomplete="off"
															v-model="vModel.City" data-vv-as='City'
															v-validate="'required'"
															:class="{'input': true, 'is-danger': errors.has('City') }" />
														<div v-show="errors.has('City')" class="help is-danger">
															{{ errors.first('City') }}
														</div>
													</div>
												</div>

												<div class="col-lg-6">
													<div class="form-group">
														<label for="">
															Post Code<span class="required">*</span>
														</label>
														<input type="text" class="form-control text-uppercase"
															id="PostCode" @input="onInput" v-only-uppercase
															placeholder="Please Enter Post Code" v-only-numeric=""
															name="PostCode" autocomplete="off" v-model="vModel.PostCode"
															data-vv-as='Post Code' v-validate="'required'"
															:class="{'input': true, 'is-danger': errors.has('PostCode') }" />
														<div v-show="errors.has('PostCode')" class="help is-danger">
															{{ errors.first('PostCode') }}
														</div>
													</div>
												</div>



											</div>
											<div class="row">
												<div class="col-lg-6">
													<b>Mailing Address</b> <br>
													<b-form-checkbox v-model="vModel.IsSameMailingAddress"
														name="IsSameMailingAddress" @input="onInput">
														<b>Same as Registered Address</b>
													</b-form-checkbox>
												</div>
											</div>
											<!-- eo row -->

											<div class="row">

												<div class="col-lg-6">
													<div class="form-group">
														<label for="">
															Unit No & Street Address<span class="required">*</span>
														</label>
														<input type="text" class="form-control text-uppercase"
															:disabled="vModel.IsSameMailingAddress" id="MailingStreet"
															placeholder="Please Enter Mailing Street"
															name="MailingStreet" autocomplete="off"
															v-model="vModel.MailingStreet"
															data-vv-as='Mailing Unit No & Street Address' v-only-uppercase
															v-validate="'required'"
															:class="{'input': true, 'is-danger': errors.has('MailingStreet') }" />
														<div v-show="errors.has('MailingStreet')"
															class="help is-danger">
															{{ errors.first('MailingStreet') }}
														</div>
													</div>
												</div>

												<div class="col-lg-6">
													<div class="form-group">
														<label for="">
															State<span class="required">*</span>
														</label>
														<div class="mb-3">
															<!--<kendo-dropdownlist data-vv-as='State' v-if='StatesCollection != null' name='StateId' v-validate="'required'"
																									class="form-control" :class="{'input': true, 'is-danger': errors.has('StateId') }" v-model="vModel.StateId"
																									:data-text-field="'Text'" :data-value-field="'Id'" :option-label="'Please Select State'" :auto-bind="true"
																									:index="0" :data-value-primitive="true" :data-source="StatesCollection">
															</kendo-dropdownlist>-->

															<select class="form-control" name="MailingStateId"
																:disabled="vModel.IsSameMailingAddress"
																v-model="vModel.MailingStateId" v-validate="'required'"
																data-vv-as='Mailing State'>
																<option value="">Please Select Mailing State</option>
																<option v-for="option in StatesCollection"
																	:key="option.Id" :value="option.Id">
																	{{option.Text}}
																</option>
															</select>

															<div v-show="errors.has('MailingStateId')"
																class="help is-danger">
																{{ errors.first('MailingStateId') }}</div>

														</div>
													</div>
												</div>

												<div class="col-lg-6">
													<div class="form-group">
														<label for="">
															City<span class='required'>*</span>
														</label>
														<input type="text" class="form-control  text-uppercase"
															:disabled="vModel.IsSameMailingAddress" id="City"
															v-only-uppercase name="MailingCity"
															placeholder="Please Enter Mailing City" autocomplete="off"
															v-model="vModel.MailingCity" data-vv-as='Mailing City'
															v-validate="'required'"
															:class="{'input': true, 'is-danger': errors.has('MailingCity') }" />
														<div v-show="errors.has('MailingCity')" class="help is-danger">
															{{ errors.first('MailingCity') }}
														</div>
													</div>
												</div>

												<div class="col-lg-6">
													<div class="form-group">
														<label for="">
															Post Code<span class="required">*</span>
														</label>
														<input type="text" class="form-control text-uppercase"
															id="MailingPostcode" :disabled="vModel.IsSameMailingAddress"
															v-only-uppercase
															placeholder="Please Enter Mailing Post Code"
															v-only-numeric="" name="MailingPostcode" autocomplete="off"
															v-model="vModel.MailingPostcode"
															data-vv-as='Mailing Post Code' v-validate="'required'"
															:class="{'input': true, 'is-danger': errors.has('MailingPostcode') }" />
														<div v-show="errors.has('MailingPostcode')"
															class="help is-danger">
															{{ errors.first('MailingPostcode') }}
														</div>
													</div>
												</div>

											</div>
											<!-- eo row -->
											<div class="row">
												<div class="col-lg-6">
													<div class="form-group">
														<label for="">
															Western Union Number:
														</label>

														<div class="input-group mb-3">
															<input type="text" id="WUNumber" name="WUNumber"
																autocomplete="off" placeholder="Please Enter WU Number"
																v-model="vModel.WUNumber" data-vv-as='WU Number'
																:class="{'input': true, 'is-danger': errors.has('WUNumber') ,'form-control' : true}"
																v-only-uppercase />

															<div class="input-group-append">
																<button class="btn btn-red-outline-secondary"
																	type="button" id="button-addon2"
																	@click="validateWUNumber">Verify</button>
															</div>
														</div>
													</div>
													<div v-show="errors.has('WUNumber')" class="help is-danger">
														{{ errors.first('WUNumber') }}
													</div>
												</div>
											</div>


										</div>
										<!-- eo form card forms -->
									</div>
									<!-- eo form card -->


								</div>
								<div class="form-card">
									<div class="form-card-header">
										<h3>Employee Details</h3>
									</div>

									<div class="form-card-forms">
										<div class="row">
											<div class="col-lg-6">
												<div class="form-group">
													<label for="">
														Company Name<span class="required">*</span>
													</label>
													<input type="text" class="form-control text-uppercase"
														v-only-uppercase id="CompanyName" name="CompanyName"
														autocomplete="off" placeholder="Please Enter Company Name"
														v-model="vModel.CompanyName" v-validate="'required'"
														data-vv-as='Company Name'
														:class="{'input': true, 'is-danger': errors.has('CompanyName') }" />
													<div v-show="errors.has('CompanyName')" class="help is-danger">
														{{ errors.first('CompanyName') }}
													</div>
												</div>
											</div>
											<div class="col-lg-6">
												<div class="form-group">
													<label for="">
														Job Title<span class="required">*</span>
													</label>
													<input type="text" class="form-control text-uppercase" id="JobTitle"
														v-only-uppercase name="JobTitle" autocomplete="off"
														placeholder="Please Enter Job Title" v-model="vModel.JobTitle"
														v-validate="'required'" data-vv-as='Job Title'
														:class="{'input': true, 'is-danger': errors.has('JobTitle') }" />
													<div v-show="errors.has('JobTitle')" class="help is-danger">
														{{ errors.first('JobTitle') }}
													</div>
												</div>
											</div>
											<!-- <div class="col-lg-6">
												<div class="form-group">
													<label for="">
														Number<span class='required'>*</span>
													</label>
													<input type="text" class="form-control" id="OfficeNumber" name="OfficeNumber" autocomplete="off"
													 placeholder="Office Number" v-model="vModel.OfficeNumber" v-validate="'required'" data-vv-as='Office Number'
													 :class="{'input': true, 'is-danger': errors.has('OfficeNumber') }" />
													<div v-show="errors.has('OfficeNumber')" class="help is-danger">
														{{ errors.first('OfficeNumber') }}
													</div>
												</div>
											</div> -->
											<!-- <div class="col-lg-6">
												<div class="form-group">
													<label for="">
														Monthly Salary<span class='required'>*</span>
													</label>
													<input type="text" class="form-control text-uppercase"
														id="mobileContact" name="MonthlySalary" v-only-numeric=""
														maxlength="10" autocomplete="off"
														placeholder="Please Enter Monthly Salary"
														v-model="vModel.MonthlySalary" v-validate="'required'"
														data-vv-as='Salary'
														:class="{'input': true, 'is-danger': errors.has('MonthlySalary') }" />
													<div v-show="errors.has('MonthlySalary')" class="help is-danger">
														{{ errors.first('MonthlySalary') }}
													</div>
												</div>
											</div> -->
											<!-- <div class="col-lg-6">
												<div class="form-group">
													<label for="">
														Average Monthly Salary<span class="required">*</span>
													</label>
													<div class="mb-3">
														<select class="form-control classic" name="MonthlySalaryRangeId"
															v-model="vModel.MonthlySalaryRangeId" v-validate="'required'"
															 data-vv-as='Salary'>
															<option :value="null">Please Select Salary Range</option>
															<option v-for="option in MonthlySalaryCollection"
																:key="option.Id" :value="option.Id">
																{{option.Text}}
															</option>
														</select>
														<div v-show="errors.has('MonthlySalaryRangeId')" class="help is-danger">
															{{ errors.first('MonthlySalaryRangeId') }}</div>
													</div>
												</div>
											</div> -->
										</div>
										<!-- <div class="row" v-if="!vModel.IsMalaysian">
											<div class="col-lg-6">
												<div class="form-group">
													<label for="">
														Address<span class='required'>*</span>
													</label>
													<input type="text" class="form-control" id="OfficeAddress" name="OfficeAddress" autocomplete="off"
													 placeholder="OfficeAddress" v-model="vModel.OfficeAddress" v-validate="'required'" data-vv-as='Office Address'
													 :class="{'input': true, 'is-danger': errors.has('OfficeAddress') }" />
													<div v-show="errors.has('OfficeAddress')" class="help is-danger">
														{{ errors.first('OfficeAddress') }}
													</div>
												</div>
											</div>
										</div> -->

										<!-- <div v-if="vModel.IsMalaysian">
											<div class="row">
												<div class="col-lg-6">
													<div class="form-group">
														<label for="" class="">
															State<span class='required'>*</span>
														</label>
														<kendo-dropdownlist data-vv-as='Office State' v-if='StatesCollection != null' name='OfficeStateMalId'
														 v-validate="'required'" class="form-control" :class="{'input': true, 'is-danger': errors.has('OfficeStateMalId') }"
														 v-model="vModel.OfficeStateMalId" :data-text-field="'Text'" :data-value-field="'Id'" :option-label="'Please Select State'"
														 :auto-bind="true" :index="0" :data-value-primitive="true" :data-source="StatesCollection">
														</kendo-dropdownlist>
														<div v-show="errors.has('OfficeStateMalId')" class="help is-danger">
															{{
															errors.first('OfficeStateMalId')
															}}
														</div>
													</div>
												</div>
												<div class="col-lg-6">
													<div class="form-group">
														<label for="" class="">
															Street<span class='required'>*</span>
														</label>
														<input type="text" class="form-control" id="OfficeStreetMal" name="OfficeStreetMal" autocomplete="off"
														 placeholder="OfficeStreetMal" v-model="vModel.OfficeStreetMal" v-validate="'required'" data-vv-as='Office Street'
														 :class="{'input': true, 'is-danger': errors.has('OfficeStreetMal') }" />
														<div v-show="errors.has('OfficeStreetMal')" class="help is-danger">
															{{ errors.first('OfficeStreetMal') }}
														</div>
													</div>
												</div>
												<div class="col-lg-6">
													<div class="form-group">
														<label for="" class="">
															City<span class='required'>*</span>
														</label>
														<input type="text" class="form-control" id="OfficeCityMal" name="OfficeCityMal" autocomplete="off"
														 placeholder="OfficeCityMal" v-model="vModel.OfficeCityMal" v-validate="'required'" data-vv-as='Office City'
														 :class="{'input': true, 'is-danger': errors.has('OfficeCityMal') }" />
														<div v-show="errors.has('OfficeCityMal')" class="help is-danger">
															{{ errors.first('OfficeCityMal') }}
														</div>
													</div>
												</div>
											</div>
											<div class="row">
												<div class="col-lg-6">
													<div class="form-group">
														<label for="" class="">
															Postal Code<span class='required'>*</span>
														</label>
														<input type="text" class="form-control" id="OfficePostCodeMal" name="OfficePostCodeMal" autocomplete="off"
														 placeholder="OfficePostCodeMal" v-model="vModel.OfficePostCodeMal" v-validate="'required'" data-vv-as='Office Post Code'
														 :class="{'input': true, 'is-danger': errors.has('OfficePostCodeMal') }" />
														<div v-show="errors.has('OfficePostCodeMal')" class="help is-danger">
															{{ errors.first('OfficePostCodeMal') }}
														</div>
													</div>
												</div>
											</div>

										</div> -->


									</div>
									<!-- eo form card forms -->
								</div>
								<!-- eo form card -->
								<div class="form-card" v-if="vModel.IsEKycUser">
									<div class="form-card-header">
										<h3>Bank Details</h3>
									</div>

									<div class="form-card-forms">
										<div class="row">
											<div class="col-lg-6">
												<div class="form-group">
													<label for="">
														Bank Name<span class="required">*</span>
													</label>
													<kendo-dropdownlist v-if="BankList != null" name='BankId'
														id='BankId' class="form-control"
														:class="{'input': true, 'is-danger': errors.has('BankId') }"
														v-validate="'required'" v-model="vModel.BankId"
														:data-text-field="'Name'" :data-value-field="'Id'"
														data-vv-as='Bank' :option-label="'Please Select Bank'"
														:auto-bind="true" :data-source="BankList"
														:data-value-primitive="true" @select="onBankSelect"
														@change="onBankChange" :disabled="true">
													</kendo-dropdownlist>

													<div v-show="errors.has('BankId')" class="help is-danger">
														{{ errors.first('BankId') }}</div>
												</div>
											</div>
											<div class="col-lg-6">
												<div class="form-group">
													<label for="">
														Bank Account No<span class="required">*</span>
													</label>
													<input type="text" class="form-control text-uppercase"
														name="AccountNumber" autocomplete="off"
														placeholder="Please Enter Bank Account No"
														v-model="vModel.BankAccountNumber" data-vv-as='Account Number'
														v-validate="BankAccValidation" v-only-uppercase
														:class="{'input': true, 'is-danger': errors.has('AccountNumber') }"
														:disabled="true">
													<div v-show="errors.has('AccountNumber')" class="help is-danger">
														{{ errors.first('AccountNumber') }}
													</div>
												</div>
											</div>
											<!-- <div class="col-lg-10">
												<div class="notice-panel">
													<div class="right-panel">
														<div class="pl-3">
															<div class="round">
																<input name="EkycBankDetails" id="EkycBankDetails"
																	v-validate="'required'" type="checkbox" />
																<label for="EkycBankDetails"></label>
																<span class="pl-4">
																	I agree that the banking details provided by me
																	above is true and in order
																</span>
															</div>
															<div class="help is-danger"
																v-show="errors.has('EkycBankDetails')">Please agree to
																terms and
																conditions to continue</div>
														</div>

													</div>
												</div>
											</div> -->
										</div>



									</div>
									<!-- eo form card forms -->
								</div>
								<!-- eo form card -->

								<div class="submit-option">
									<div class="left-option">
										<router-link :to="'/dashboard'" class="btn submit-lefticon-btn">
											<span class="left-icon">
												<i class="fas fa-angle-left"></i>
											</span>
											<span class="btn-content">Cancel</span>
										</router-link>
									</div>

									<div class="right-option">
										<button class="btn submit-lefticon-btn">
											<span class="left-icon">
												<i class="fas fa-envelope"></i>
											</span>
											<span class="btn-content">Update</span>
										</button>
									</div>
								</div>
							</form>
						</div>
						<!-- eo col-8 -->

						<div class="col-lg-4">
							<UserDetailSection />							
						</div>						
					</div>
					<!-- eo row -->

				</div>
				<!-- eo main card -->

			</div>
			<!-- eo container -->
		</div>
		<!-- eo main section -->
	</div>
</template>

<script>

	import ListService from "../../services/list";
	import Base from "../../shared/Base.vue";
	import UserDetailSection from "../../shared/UserDetailSection.vue";
	import commonService from "../../services/common";

	export default {
		extends: Base,
		name: "Profile",
		components: {
			UserDetailSection
		},

		beforeRouteEnter(to, from, next) {
			var promises = [];
			promises.push(
				ListService.get("list/occupation"),
				ListService.get("list/state"),
				//ListService.get("list/employmentpositionlevel"),
				ListService.get("customer/profile"),
				ListService.get("list/getallrefundbank"),
				ListService.get("list/ListMonthlySalaryRange")

			);
			Promise.all(promises).then(response => {
				next(p => {
					p.OccupationCollection = response[0].body;
					p.StatesCollection = response[1].body;
					//p.EmploymentLevelCollection = response[2].body;
					p.vModel = response[2].body;
					p.BankList = response[3].body;
					p.MonthlySalaryCollection =response[4].body;
					if (p.vModel.OccupationId) {

						var occupation = p.OccupationCollection.filter((s) => {
							return s.Id == p.vModel.OccupationId;
						})[0];

						if (occupation)
							p.SubOccupationCollection = occupation.SubOccupations.map(
								function (m) {
									return {
										Id: m.Id,
										Text: m.Text,
										EmploymentLevel: m.EmployeementLevels,
										EmploymentIndustries:m.EmploymentIndustries,
										ShowEmploymentIndustry:m.ShowEmploymentIndustry
									}
								});
					}

					if (p.vModel.SubOccupationId) {
						var suboccupation = p.SubOccupationCollection.filter((s) => {
							return s.Id == p.vModel.SubOccupationId;
						})[0];
						console.log('suboccupation',suboccupation)
						if (suboccupation){
							p.EmploymentLevelCollection = suboccupation.EmploymentLevel.map(
								function (m) {
									return {
										Id: m.Id,
										Text: m.Text,
										DefaultValue: m.DefaultValue
									}
								});
							p.EmploymentIndustries = [...suboccupation.EmploymentIndustries];
							p.ShowEmploymentIndustry = suboccupation.ShowEmploymentIndustry;
						}
					}
				});
			});
		},
		created() {
			this.url.add = "customer/profile/save";
			this.url.update = "customer/profile/save";
			this.url.redirect = "dashboard";
			this.AddressValidationModel = commonService.getUserAddressValidation();
		},

		data() {
			return {
				StatesCollection: null,
				OccupationCollection: [],
				MonthlySalaryCollection:[],
				SubOccupationCollection: [],
				EmploymentLevelCollection: [],
				BankList: null,
				BankAccValidation: 'required',
				AddressValidationModel: {},
				ShowEmploymentIndustry:false,
				EmploymentIndustries:[],
				vModel: {
					Nationality: "",
					DateOfBirth: "",
					PassportNumber: "",
					PassportExpirydate: "",
					VisaExpiryDate: "",
					WorkContact: "",
					MobileContact: "",
					City: "",
					PostCode: "",
					Street: "",
					StateId: "",
					OccupationId: null,
					SubOccupationId: "",
					MonthlySalary: "",
					MonthlySalaryRangeId:"",
					JobTitle: "",
					OfficeAddress: "",
					CompanyName: "",
					OfficeNumber: "",
					BonusCardNumber: "",
					OtherOccupation: null,
					IsMalaysian: false,
					CountryOfBirthName: null,
					Email: null,
					OfficeStateMalId: null,
					OfficeStreetMal: null,
					OfficePostCodeMal: null,
					OfficeCityMal: null,
					WUNumber: null,
					EmploymentLevelId: null,
					BankAccountNumber: null,
					BankId: null,
					IsEKycUser: null,
					IsSameMailingAddress: false,
					MailingStreet: '',
					MailingPostcode: '',
					MailingCity: '',
					MailingStateId: ''
				}
			};
		},
		methods: {
			validateWUNumber() {
				if (this.vModel.WUNumber) {
					ListService.get("customer/wunumber/check/" + this.vModel.WUNumber).then(
						res => {
							this.$toastr("success", "Valid Western Union Membership No.");
						}
					);
				}
			},

			onOccupationChange(e) {
				this.vModel.SubOccupationId = null;
				this.vModel.EmploymentLevelId = null;


				this.SubOccupationCollection = [];
				this.EmploymentLevelCollection = [];


				if (this.vModel.OccupationId) {

					var sub = this.OccupationCollection.filter((s) => {
						return s.Id == this.vModel.OccupationId;
					})[0];

					if (sub)
						this.SubOccupationCollection = sub.SubOccupations.map(	
							function (m) {
								return {
									Id: m.Id,
									Text: m.Text,
									EmploymentLevel: m.EmployeementLevels,
									EmploymentIndustries: m.EmploymentIndustries,
									ShowEmploymentIndustry: m.ShowEmploymentIndustry
								}
							});
				}
			},
			onSubOccupationChange(e) {
				this.vModel.EmploymentLevelId = null;
				this.EmploymentLevelCollection = [];
				if (this.vModel.SubOccupationId) {
					var sub = this.SubOccupationCollection.filter((s) => {
						return s.Id == this.vModel.SubOccupationId;
					})[0];
					if (sub) {
						this.EmploymentIndustries = [...sub.EmploymentIndustries];
						this.ShowEmploymentIndustry = sub.ShowEmploymentIndustry;
						this.EmploymentLevelCollection = sub.EmploymentLevel.map(
							function (m) {
								return {
									Id: m.Id,
									Text: m.Text,
									DefaultValue: m.DefaultValue
								}
							});

						if (this.EmploymentLevelCollection.length) {
							var defaultValue = this.EmploymentLevelCollection.filter((s) => {
								return s.DefaultValue;
							})[0];
							if (defaultValue)
								this.vModel.EmploymentLevelId = defaultValue.Id;
						}
					}
				}
			},
			onBankSelect(e) {
				console.log(e.dataItem)
				if (this.vModel.BankId == e.dataItem.Id) {
					return false;
				}

				if (e.dataItem.RangeFrom && e.dataItem.RangeTo) {
					this.BankAccValidation = `required|min:${e.dataItem.RangeFrom}|max:${e.dataItem.RangeTo}`;
				} else {
					this.BankAccValidation = 'required';
				}



			},
			onBankChange(e) {
			},
			onSubmit() {
				var self = this;
				if (self.isProcessing) return;

				self.$validator.validateAll().then(result => {
					if (result && this.beforeSave()) {
						var url = self.id === undefined ? self.url.add : self.url.update;
						self.isProcessing = true;

						self.$http.post(url, self.vModel).then(
							response => {
								self.$toastr("success", "We're currently verifying your information. Changes will reflect within 24 hours.");

								if (!self.AddressValidationModel.IsValid) {
									//Delete Global Banners show flag might have been set in dashboard
									window.bannersToShow = undefined;
								}
								//UPDATE ADDRESS VALIDATION
								self.AddressValidationCheck = {
									IsValid: true,
									DisplayMessage: ''
								}
								commonService.setStorage('addressValidation', JSON.stringify(self.AddressValidationCheck));
								commonService.setStorage('employeeIndustryCheck', JSON.stringify(self.AddressValidationCheck));
								//
								self.$router.push(
									"/" + self.url.redirect !== ""
										? self.url.redirect
										: self.url.init
								);
								self.isProcessing = false;
							},
							error => {
								self.isProcessing = false;
							}
						);
					}
				});
			},
			onInput() {
				if (this.vModel.IsSameMailingAddress) {
					this.vModel.MailingStreet = this.vModel.Street;
					this.vModel.MailingPostcode = this.vModel.PostCode;
					this.vModel.MailingCity = this.vModel.City;
					this.vModel.MailingStateId = this.vModel.StateId;
				} else {
					this.vModel.MailingStreet = '',
						this.vModel.MailingPostcode = '';
					this.vModel.MailingCity = '';
					this.vModel.MailingStateId = '';
				}
			},
			
		},

	};
</script>
